import type { ModOrigin } from '../api/catalog';
import { ca } from '../i18n/ca';

/**
 * Which mod something comes from, in words: the mod's name, a Creator DLC's,
 * "Arma 3" for the base game, the Workshop id when the mod gave no name.
 * `unknown` and `unread` are said as such, never guessed from a class name.
 */
export function modOriginLabel(o: ModOrigin): string {
  const t = ca.modOrigin;
  switch (o.kind) {
    case 'game':
      return o.name || t.game;
    case 'cdlc':
      return o.name || t.cdlcTitle;
    case 'mod':
      if (o.name) return o.name;
      return o.workshopId ? t.workshop(o.workshopId) : t.unknown;
    case 'unread':
      return t.unread;
    default:
      return t.unknown;
  }
}
